/**
 * textColorClassNameMapping returns an object that maps color names to their corresponding CSS class names
 * It includes mappings for Light, Medium, Dark, and Default colors
 * This object is used for mapping of text color class names to Contentful dropdown values
 */
const textColorClassNameMapping = {
    Light: "text-white",
    Medium: "text-gray",
    Dark: "text-blue",
    Default: "",
};

/**
 * colorMapping returns an object that maps color names to their corresponding CSS class names for background color, primary text color, and secondary text color
 * Each color has a background color (bgColor), primary text color (primaryTextColor), and secondary text color (secondaryTextColor).
 * This object is used for mapping of color class names to Contenful dropdown values
 */
const colorMapping = {
    Main: {
        bgColor: "bg-blue",
        primaryTextColor: textColorClassNameMapping.Light,
        secondaryTextColor: textColorClassNameMapping.Light,
    },
    Secondary: {
        bgColor: "bg-ocean",
        primaryTextColor: textColorClassNameMapping.Light,
        secondaryTextColor: textColorClassNameMapping.Light,
    },
    Highlight: {
        bgColor: "bg-orange",
        primaryTextColor: textColorClassNameMapping.Light,
        secondaryTextColor: textColorClassNameMapping.Medium,
    },
    Positive: {
        bgColor: "bg-green",
        primaryTextColor: textColorClassNameMapping.Light,
        secondaryTextColor: textColorClassNameMapping.Medium,
    },
    Negative: {
        bgColor: "bg-dark-green",
        primaryTextColor: textColorClassNameMapping.Light,
        secondaryTextColor: textColorClassNameMapping.Medium,
    },
    Dark: {
        bgColor: "bg-gray",
        primaryTextColor: textColorClassNameMapping.Light,
        secondaryTextColor: textColorClassNameMapping.Medium,
    },
    Light: {
        bgColor: "bg-stone",
        primaryTextColor: textColorClassNameMapping.Dark,
        secondaryTextColor: textColorClassNameMapping.Light,
    },
    "Medium Light": {
        bgColor: "bg-light-casper",
        primaryTextColor: textColorClassNameMapping.Dark,
        secondaryTextColor: textColorClassNameMapping.Medium,
    },
    Medium: {
        bgColor: "bg-stone-light",
        primaryTextColor: textColorClassNameMapping.Dark,
        secondaryTextColor: textColorClassNameMapping.Medium,
    },
    Neutral: {
        bgColor: "bg-december-sky",
        primaryTextColor: textColorClassNameMapping.Dark,
        secondaryTextColor: textColorClassNameMapping.Dark,
    },
    Accent: {
        bgColor: "bg-sky",
        primaryTextColor: textColorClassNameMapping.Dark,
        secondaryTextColor: textColorClassNameMapping.Dark,
    },
    Soft: {
        bgColor: "bg-gainsboro",
        primaryTextColor: textColorClassNameMapping.Dark,
        secondaryTextColor: textColorClassNameMapping.Dark,
    },
    White: {
        bgColor: "bg-white",
        primaryTextColor: textColorClassNameMapping.Dark,
        secondaryTextColor: textColorClassNameMapping.Dark,
    },
    None: {
        bgColor: "bg-transparent",
        primaryTextColor: textColorClassNameMapping.Default,
        secondaryTextColor: textColorClassNameMapping.Default,
    },
    Default: {
        bgColor: "",
        primaryTextColor: textColorClassNameMapping.Default,
        secondaryTextColor: textColorClassNameMapping.Default,
    },
    Gradient: {
        bgColor: "gradient-gray",
        primaryTextColor: textColorClassNameMapping.Default,
        secondaryTextColor: textColorClassNameMapping.Default,
    },
    "Blue Gradient": {
        bgColor: "gradient-blue",
        primaryTextColor: textColorClassNameMapping.Light,
        secondaryTextColor: textColorClassNameMapping.Light,
    },
};

/**
 * getColorClassName returns a function that retrieves the color class names for a section and a card based on the provided keys.
 * It first tries to get the color mapping for the @backgroundColorKey and the @cardItemBackgroundColorKey
 * If the color mapping does not exist for a key, it uses the default color mapping
 */
const getColorClassName = (backgroundColorKey, cardItemBackgroundColorKey) => {
    const sectionColorMapping = colorMapping[backgroundColorKey] || colorMapping.Default;
    const cardColorMapping = colorMapping[cardItemBackgroundColorKey] || colorMapping.Default;

    return { sectionColorMapping, cardColorMapping };
};

export { getColorClassName };
